import React from 'react';
import { TrendingUp, Euro, Gauge } from 'lucide-react';
import { economicsData } from '../../data/mock';

const iconMap = {
  TrendingUp: TrendingUp,
  Euro: Euro,
  Gauge: Gauge
};

const EconomicsSection = () => {
  return (
    <section id="economics" className="py-12 sm:py-16 lg:py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-16">
          <span className="inline-block px-3 py-1 rounded-full bg-emerald-50 text-emerald-700 text-xs sm:text-sm font-medium mb-3 sm:mb-4 border border-emerald-200">
            Beispielhafte Wirtschaftlichkeit
          </span>
          <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-slate-800 mb-3 sm:mb-4">
            Ihre Investition zahlt sich aus
          </h2>
          <p className="text-sm sm:text-base text-slate-600 max-w-2xl mx-auto px-4">
            Konkrete Kennzahlen, die für sich sprechen.
          </p>
        </div>

        {/* Economics Cards */}
        <div className="grid grid-cols-3 gap-3 sm:gap-6 mb-6 sm:mb-8">
          {economicsData.map((item, index) => {
            const Icon = iconMap[item.icon];
            return (
              <div 
                key={index}
                className="group p-4 sm:p-8 rounded-xl bg-white border border-slate-200 hover:border-emerald-300 hover:shadow-sm transition-all text-center"
              >
                <div className="w-10 h-10 sm:w-14 sm:h-14 rounded-lg sm:rounded-xl bg-emerald-50 border border-emerald-200 flex items-center justify-center mx-auto mb-3 sm:mb-6">
                  <Icon className="w-5 h-5 sm:w-7 sm:h-7 text-emerald-600" />
                </div>
                
                <div className="mb-1 sm:mb-2">
                  <span className="text-xl sm:text-3xl md:text-4xl font-semibold text-slate-800">{item.value}</span>
                  <span className="text-sm sm:text-lg md:text-xl font-medium text-slate-600 ml-0.5 sm:ml-1">{item.unit}</span>
                </div>
                
                <p className="text-xs sm:text-sm md:text-base text-slate-600 font-medium">{item.label}</p>
              </div>
            );
          })}
        </div>

        {/* Disclaimer */}
        <p className="text-center text-xs sm:text-sm text-slate-500 px-4">
          * Werte sind projektabhängig und beispielhaft dargestellt.
        </p>
      </div>
    </section>
  );
};

export default EconomicsSection;
